<template>
  <div class="conversation-item" :class="{'my':item.send}">
    <van-image :src="item?.user_extra?.avatar" round class="user-avatar" />
    <div class="info">
      <div class="title">
        <h3 class="name">{{item?.user_extra?.nickname||'匿名'}}</h3>
        <!-- <img :src="getLvUrl(item?.user_extra?.level)" class="img-lv" /> -->
        <!-- <p class="time">
          {{moment(item.timestamp * 1000).format('HH:mm')}}
        </p> -->
        <div v-if="state.czshow" class="cz-box" ref="popupRef">
          <div class="cz-box-item" @click="sendDataToAncestor(item)">
            回复
          </div>
          <div v-if="isChShow(item)" class="cz-box-item" @click="onCh(item)">
            撤回
          </div>
        </div>
      </div>
      <img :src="item.content.url" class="pl-img" @touchstart="handleTouchStart" @touchend="handleTouchEnd"
        @touchcancel="handleTouchEnd" @mousedown="handleMouseDown" @mouseup="handleMouseUp" @mouseleave="handleMouseUp"
        @click="openImage(item.content.url)" />
    </div>
    <div class="status" v-if="item.status != MessageStatus.Normal && item.send">发送中</div>
  </div>
</template>
<script>
  import {
    reactive,
    onMounted,
    ref,
    onUnmounted,
    inject
  } from 'vue'
  import {
    useRouter
  } from 'vue-router'
  import {
    Toast
  } from 'vant'
  import {
    useStore
  } from "vuex"
  import moment from 'moment';
  import {
    Channel,
    ChannelTypePerson,
    ChannelTypeGroup,
    WKSDK,
    MessageStatus
  } from "wukongimjssdk";
  import {
    ImagePreview
  } from 'vant'
  import {
    messageRevoke
  } from "@/api/im.js";
  import {
    GroupRole
  } from "@/services/const.js";


  export default {
    name: 'conversationitemtext',
    props: ['item'],
    setup() {
      const store = useStore()

      const router = useRouter()
      const popupRef = ref(null)
      const state = reactive({
        uid: store.state.imuid,
        // 操作
        czshow: false,
      })
      // 获取等级
      const getLvUrl = (lv) => {
        // if (lv) {
        //   return require(`@/assets/lv/${lv}.png`)
        // } else {
        //   return require(`@/assets/lv/0.png`)
        // }

      }
      // 获取头像
      const getAvatar = (fromUID) => {
        return `${process.env.VUE_APP_BASE_IM_API}/api/v1/users/${fromUID}/avatar?v=`
      }
      // 获取昵称
      const getName = (fromUID) => {
        const channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(fromUID, ChannelTypePerson))
        return channelInfo?.orgData.displayName
        // if (!channelInfo && fromUID && fromUID !== "") {
        //   WKSDK.shared().channelManager.fetchChannelInfo(new Channel(fromUID, ChannelTypePerson)).then(()=>{
        //     // 获取单人频道信息
        //     const channelInfo = WKSDK.shared().channelManager.getChannelInfo(new Channel(fromUID, ChannelTypePerson))
        //     return channelInfo?.orgData.displayName
        //   })
        // }
      }

      const imageScale = (orgWidth, orgHeight, maxWidth = 250, maxHeight = 250) => {
        let actSize = {
          width: orgWidth,
          height: orgHeight
        };
        if (orgWidth > orgHeight) { //横图
          if (orgWidth > maxWidth) { // 横图超过最大宽度
            let rate = maxWidth / orgWidth; // 缩放比例
            actSize.width = maxWidth;
            actSize.height = orgHeight * rate;
          }
        } else if (orgWidth < orgHeight) { //竖图
          if (orgHeight > maxHeight) {
            let rate = maxHeight / orgHeight; // 缩放比例
            actSize.width = orgWidth * rate;
            actSize.height = maxHeight;
          }
        } else if (orgWidth === orgHeight) {
          if (orgWidth > maxWidth) {
            let rate = maxWidth / orgWidth; // 缩放比例
            actSize.width = maxWidth;
            actSize.height = orgHeight * rate;
          }
        }
        return actSize;
      }

      const openImage = (url) => {
        console.log(123)
        ImagePreview([url])
      }

      // 判断是否能撤回
      const isChShow = (message) => {
        if (message.messageID == "") {
          return false;
        }

        let isManager = false;
        if (message.channel.channelType == ChannelTypeGroup) {
          const sub = WKSDK.shared().channelManager.getSubscribeOfMe(
            message.channel
          );
          if (sub?.role == GroupRole.manager || sub?.role == GroupRole.owner) {
            isManager = true;
          }
        }

        if (!isManager) {
          if (!message.send) {
            return false;
          }
          let revokeSecond = 2 * 60;
          if (revokeSecond > 0) {
            const messageTime = new Date().getTime() / 1000 - message.timestamp;
            if (messageTime > revokeSecond) {
              //  超过两分钟则不显示撤回
              return false;
            }
          }
        }

        return true
      }

      // 定时器标识
      let pressTimer = null

      // 长按阈值（毫秒），可根据需求调整
      const LONG_PRESS_TIME = 500

      // 标记是否是触摸操作（避免touch和mouse事件重复触发）
      const isTouch = ref(false)

      // 触摸开始/鼠标按下事件
      const startPress = () => {
        // 启动定时器，达到阈值后显示弹窗
        pressTimer = setTimeout(() => {
          state.czshow = true
          // 弹窗显示后添加全局点击监听
          document.addEventListener('click', handleClickOutside)
        }, LONG_PRESS_TIME)
      }

      // 触摸结束/鼠标松开事件
      const endPress = () => {
        // 清除定时器，取消长按判定
        if (pressTimer) {
          clearTimeout(pressTimer)
          pressTimer = null
        }
      }

      // 触摸事件处理
      const handleTouchStart = () => {
        // e.preventDefault() // 阻止默认行为（如滚动）
        isTouch.value = true
        // 注意：不要在这里调用 e.preventDefault()，否则会阻断click
        startPress()
      }
      const handleTouchEnd = () => {
        isTouch.value = false
        endPress()
      }

      // 鼠标事件处理（兼容PC端）
      const handleMouseDown = () => {
        if (isTouch.value) return // 跳过触摸触发的mouse事件
        // e.preventDefault()
        startPress()
      }
      const handleMouseUp = () => {
        if (isTouch.value) return // 跳过触摸触发的mouse事件
        endPress()
      }
      // 监听点击外部区域
      const handleClickOutside = (e) => {
        if (popupRef.value && !popupRef.value.contains(e.target)) {
          closePopup()
        }
      }
      // 关闭弹窗
      const closePopup = () => {
        state.czshow = false
        // 移除全局点击监听
        document.removeEventListener('click', handleClickOutside)
      }
      // 撤回消息
      const onCh = (item) => {
        messageRevoke({
          channel_id: item.channel.channelID,
          channel_type: item.channel.channelType,
          message_id: item.messageID,
          client_msg_no: item.clientMsgNo,
        }).then(() => {
          Toast('撤回成功')
        }).catch((err) => {
          Toast(err.msg);
        })
        closePopup()
      }
      onMounted(() => {

      })
      onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside)
      })
      // 返回
      const onClickLeft = () => {
        router.back()
      }
      // 注入祖宗组件提供的方法（key 要和 provide 的一致）
      const triggerAncestorMethod = inject('triggerAncestorMethod')
      // 点击回复触发，向祖宗组件传值
      const sendDataToAncestor = (item) => {
        // 传任意值（字符串、对象、数组等）
        triggerAncestorMethod(item)
        closePopup()
      }
      return {
        popupRef,
        MessageStatus,
        moment,
        state,
        onClickLeft,
        getAvatar,
        getName,
        imageScale,
        openImage,
        handleTouchEnd,
        handleMouseUp,
        handleMouseDown,
        handleTouchStart,
        getLvUrl,
        onCh,
        isChShow,
        sendDataToAncestor,
      }
    }
  }
</script>
<style scoped="scoped">
  .conversation-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
  }

  .conversation-item .user-avatar {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    flex-shrink: 0;
  }

  .conversation-item .info {
    padding-left: 10px;
  }

  .conversation-item .info .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
  }

  .conversation-item .info .title .img-lv {
    width: 70px;
    margin-left: 10px;
  }

  .conversation-item .info .name {
    font-size: 28px;
    color: #fff;

  }

  .conversation-item .info .pl-content {
    color: #333;
    font-size: 26px;
    margin-bottom: 10px;
  }

  .conversation-item .info .time {
    font-size: 24px;
    color: #999;
  }

  .conversation-item .info .pl-img {
    border-radius: 10px;
    max-width: 500px;
  }

  .conversation-item.my {
    flex-direction: row-reverse;
    text-align: right;
  }

  .conversation-item.my .user-avatar {
    margin-right: 0;
    margin-left: 20px;
    flex-shrink: 0;
  }

  .conversation-item.my .info {}

  .conversation-item.my .title {
    justify-content: flex-end;
  }

  .conversation-item.my .title .time {
    color: #999;
  }

  .conversation-item.my .pl-img {
    max-width: 500px;
  }

  .conversation-item .status {
    font-size: 24px;
    color: rgb(228, 98, 64);
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .cz-box {
    position: absolute;
    bottom: 0;
    right: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px 2px rgba(114, 114, 114, 0.25);
    border-radius: 20px;
  }

  .cz-box .cz-box-item {
    font-size: 26px;
    color: #666;
    padding: 20px 40px;
  }
</style>